"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const scheduleData = [{
  id: "evt-1",
  date: "April 15-17, 2025",
  eventName: "Rocky Mountain Cavalier Specialty",
  location: "Denver, CO",
  status: "Registration Open",
  linkText: "View Details",
  linkUrl: "#"
}, {
  id: "evt-2",
  date: "May 22-24, 2025",
  eventName: "Mile High All-Breed Dog Show",
  location: "Colorado Springs, CO",
  status: "Upcoming",
  linkText: "View Details",
  linkUrl: "#"
}, {
  id: "evt-3",
  date: "June 12, 2025",
  eventName: "Summer Cavalier Showcase",
  location: "Boulder, CO",
  status: "Upcoming",
  linkText: "View Details",
  linkUrl: "#"
}, {
  id: "evt-4",
  date: "July 5-7, 2025",
  eventName: "National CKCS Championship",
  location: "Las Vegas, NV",
  status: "Planning",
  linkText: "View Details",
  linkUrl: "#"
}];
const getBadgeVariant = (status: string) => {
  switch (status) {
    case "Registration Open":
      return "default";
    case "Upcoming":
      return "secondary";
    default:
      return "outline";
  }
};
export default function ShowSchedule() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}